import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, json } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Statistic,
  Spin,
  Button,
  Form,
  Row,
  Col,
  Flex,
  Steps,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../../../components/layouts/MainLayout";
import CustomButton from "../../../../../components/custom/CustomButton";
import TopContent from "../../../../../components/layouts/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import DetailForm from "./forms/DetailForm";
import ChargesForm from "./forms/ChargesForm";
import TermsForm from "./forms/TermsForm";
import Preview from "./forms/Preview";
import "../../steps.css";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { apiConfig, labelConfig, staticConfig } from "../../../group.config";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";
import SettingsForm from "./forms/SettingsForm";
import appConfig from "../../../../../config/appConfig";

const GLIMLoanApplication = (props) => {
  const { state } = useLocation();

  //DECLARED VARIABLES
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isStepDisabled, setIsStepDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [groupInfo, setGroupInfo] = useState(null);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [customerParam, setCustomerParam] = useState({});
  const [loanTermTypeData, setLoanTermTypeData] = useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [fundData, setFundData] = useState([]);
  const [clientMembersData, setClientMembersData] = useState([]);
  const [onData, setOnData] = useState([]);
  const [isRepaidEveryMonth, setIsRepaidEveryMonth] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [lastApplication, setLastApplication] = useState(false);
  const [productId, setProductId] = useState(0);
  const [principal, setPrincipal] = useState(0);
  const [dayData, setdayData] = useState([]);
  const [clientMembersArray, setClientMembersArray] = useState([]);
  const [accountLinkingOptions, setAccountLinkingOptions] = useState([]);
  const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [interestRateType, setInterestRateType] = useState("");
  const [searchParam, setSearchParam] = useState("");
  const [glimLoanProdDetails, setGlimLoanProdDetails] = useState([]);

  const { userData } = props;
  const { Text } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // CHARGES FORM REQUIRED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [productOptions, setProductOptions] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});

  const [charges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    details: null,
    terms: null,
    charges: null,
  });

  useEffect(() => {
    getTemplate();
    getGsimAccounts();
  }, []);

  const getTemplate = () => {
    const url = `${apiConfig.Loans}/template`;
    const params = {
      groupId: state.id,
      lendingStrategy: 300,
      templateType: "jlgbulk",
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempProductOptions = [];

        objDetail?.productOptions.forEach((element) => {
          tempProductOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        useForm.setFieldsValue({
          repaymentsStartingFromDate: dayjs(),
          interestChargedFromDate: dayjs(),
          submittedOnDate: dayjs(),
          expectedDisbursementDate: dayjs(),
        });
        setProductOptions(tempProductOptions);
        setIsLoading(false);
      }
    });
  };

  const getGsimAccounts = () => {
    const url = `${apiConfig.Groups}/${state.id}/gsimaccounts`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempAccountLinkingOptions = [];

        objList?.forEach((element) => {
          tempAccountLinkingOptions.push({
            value: element?.gsimId,
            label: element?.accountNumber,
          });
        });
        setAccountLinkingOptions(tempAccountLinkingOptions);

        setIsLoading(false);
      }
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const onSearch = () => {
    setIsProductSelected(false);
    useForm.resetFields();
    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };
    const url = apiConfig.Search;
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo
              ? element.entityAccountNo
              : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo
              ? element.entityMobileNo
              : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.entityType ? element.entityType : "",
          });
        });

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerParam(tempProducts[0]);
        setGroupInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;

    values.expectedDisbursementDate = values.expectedDisbursementDate
      ? BOM.DateTime(values.expectedDisbursementDate, "only-date")
      : values.expectedDisbursementDate;

    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    values.interestChargedFromDate = values.interestChargedFromDate
      ? BOM.DateTime(values.interestChargedFromDate, "only-date")
      : values.interestChargedFromDate;

    values.repaymentsStartingFromDate = values.repaymentsStartingFromDate
      ? BOM.DateTime(values.repaymentsStartingFromDate, "only-date")
      : values.repaymentsStartingFromDate;

    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      let tempClientMembersArray = [];
      tempClientMembersArray = selectedRows;
      setClientMembersArray(tempClientMembersArray);
      setSelectedRows(selectedRows);
    },
  };

  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      if (element.dueDate === "-") {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
        });
      } else {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
          dueDate: BOM.DateTime(element.dueDate, "only-date"),
        });
      }
    });

    values.charges = tempChargeArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
    });
    setCurrent(current + 1);
  };

  const onFinishSettingsForm = (values) => {
    setFormData({
      ...formData,
      settings: clientMembersArray,
    });

    setCurrent(current + 1);
  };

  const getProductTemplate = (customerParam) => {
    setIsLoading(true);
    const params = {
      clientId: `${customerParam.entityId}`,
      staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.SavingsAccounts}/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        let tempProducts = [];

        objDetail?.productOptions
          ?.filter((item) => item.allowOverdraft === true)
          .forEach((element) => {
            tempProducts.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        setProductOptions(tempProducts);
        setGroupInfo(customerParam);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam, option, value) => {
    setIsStepDisabled(false);
    setIsLoading(true);
    setProductId(productParam);
    const params = {
      groupId: state.id,
      productId: productParam,
      lendingStrategy: 300,
      templateType: "jlgbulk",
    };
    const url = `${apiConfig.Loans}/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setTemplateProdDetail(res);
        const objDetail = res;

        let tempFieldOfficer = [];
        let tempCurrency = objDetail?.currency;
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempFundData = [];
        let tempLoanTermTypeData = [];
        let tempInterestTypeOptions = [];
        let tempClientMembersData = [];
        let tempLoanPurposeOptions = [];
        let tempOnData = [];
        let tempDayData = [];
        const originalLoan = objDetail?.approvedPrincipal;

        useForm.setFieldsValue({
          productId: productParam,
          loanTermFrequencyType: objDetail?.termPeriodFrequencyType?.id,
          loanTermFrequency: objDetail?.termFrequency,
          repaymentEvery: objDetail?.repaymentEvery,
          repaymentFrequencyType: objDetail?.repaymentFrequencyType?.id,
          numberOfRepayments: objDetail?.numberOfRepayments,
          interestRatePerPeriod: objDetail?.interestRatePerPeriod,
          interestType: objDetail?.interestType?.id,
        });

        objDetail?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach(
          (element) => {
            tempDayData.push({
              value: element?.id,
              label: element?.value,
            });
          }
        );
        objDetail?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
          tempOnData.push({
            value: element?.id,
            label: element?.value,
          });
        });
        objDetail?.loanPurposeOptions?.forEach((element) => {
          tempLoanPurposeOptions.push({
            value: element?.id,
            label: element?.name,
          });
        });
        objDetail?.group?.clientMembers?.forEach((element) => {
          tempClientMembersData.push({
            key: element?.id,
            clientId: element?.id,
            clientName: element?.displayName,
            loanPurposeId: " - ",
            originalLoan,
          });
        });
        objDetail?.interestTypeOptions?.forEach((element) => {
          tempInterestTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.loanOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });
        objDetail?.termFrequencyTypeOptions?.forEach((element) => {
          tempLoanTermTypeData.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.fundOptions?.forEach((element) => {
          tempFundData.push({
            value: element.id,
            label: element.name,
          });
        });
        const chargesLength = objDetail?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objDetail?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            dueDate: element?.feeOnMonthDay
              ? BOM.DateTime(element?.feeOnMonthDay, "only-date")
              : "-",
            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });
        objDetail?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
          });
        });
        objDetail?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        if (
          objDetail?.repaymentFrequencyType?.value.toLowerCase() === "months"
        ) {
          setIsRepaidEveryMonth(true);
        } else {
          setIsRepaidEveryMonth(false);
        }

        setFieldOfficerData(tempFieldOfficer);
        setInterestTypeOptions(tempInterestTypeOptions);
        setFundData(tempFundData);
        setOnData(tempOnData);
        setdayData(tempDayData);
        setLoanTermTypeData(tempLoanTermTypeData);
        setClientMembersData(tempClientMembersData);
        setLoanPurposeOptions(tempLoanPurposeOptions);
        setChargeTableSource(tempCharges);
        setPrincipal(objDetail?.principal);
        setInterestRateType(objDetail?.interestRateFrequencyType?.value);

        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions(tempChargesOptions);
        setIsProductSelected(true);
        setShowDetailsForm(true);
        setGlimLoanProdDetails(objDetail);
        setIsLoading(false);
      }
    });
    getCollateralLoanTemplateType(productParam);
  };

  const getCollateralLoanTemplateType = (productParam) => {
    setIsStepDisabled(false);
    setIsLoading(true);
    const params = {
      fields: "id,loanCollateralOptions",
      productId: productParam,
      templateType: "collateral",
    };
    const url = `${apiConfig.Loans}/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        // setTemplateProdDetail(res);
        const objDetail = res;

        setIsLoading(false);
      }
    });
  };

  const forms = [
    <DetailForm
      onSearch={onSearch}
      searchParam={searchParam}
      groupInfo={groupInfo}
      fundData={fundData}
      showDetailsForm={showDetailsForm}
      onFinish={onFinishDetailsForm}
      currencyData={currencyData}
      displayFields={isProductSelected}
      form={useForm}
      initialValues={formData.details}
      onChangeProduct={onChangeProduct}
      productOptions={productOptions}
      fieldOfficerData={fieldOfficerData}
      handleSearchInTable={handleSearchInTable}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      form={useForm}
      initialValues={formData.terms}
      loanTermTypeData={loanTermTypeData}
      interestTypeOptions={interestTypeOptions}
      onData={onData}
      glimLoanProdDetails={glimLoanProdDetails}
      isRepaidEveryMonth={isRepaidEveryMonth}
      dayData={dayData}
      interestRateType={interestRateType}
    />,

    <ChargesForm
      onFinish={onFinishChargeForm}
      form={useForm}
      userData={userData}
      initialValues={formData.charges}
      chargePlaceholder={BOM.handlePlaceholderMsg(
        labelConfig.charges,
        "select"
      )}
      chargesOptions={chargesOptions}
      chargesData={charges}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setChargesValue={setChargesValue}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      chargeTableCount={chargeTableCount}
      setChargeTableCount={setChargeTableCount}
    />,

    <SettingsForm
      form={useForm}
      userData={userData}
      onFinish={onFinishSettingsForm}
      clientMembersData={clientMembersData}
      setClientMembersData={setClientMembersData}
      loanPurposeOptions={loanPurposeOptions}
      rowSelection={rowSelection}
      accountLinkingOptions={accountLinkingOptions}
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      templateProdDetail={templateProdDetail}
      productOptions={productOptions}
      groupInfo={groupInfo}
      chargeTableSource={chargeTableSource}
      clientMembersArray={clientMembersArray}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    if (!isStepDisabled) {
      useForm.submit();
    } else {
      return null;
    }
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/detail-group", {
      state: {
        id: state.id,
      },
    });
  }
  // const request = (url, method, data) => {
  //     const { headers } = appConfig.apiSettings;
  //     headers.Authorization = session;

  //     axios({
  //         url,
  //         method,
  //         headers,
  //         data
  //     })
  //         .then(function (res) {
  //             BOM.AlertMsg(cnt.SUCCESS, labelConfig.newGLIMLoanAppMsg);
  //             const objDetail = res;
  //             navigate("/detail-group", {
  //                 state: {
  //                     id: state?.id,
  //                     statusValue: accountStatus.submittedAndPending,
  //                 },
  //             });

  //             //STOP LOAD
  //             setIsLoading(false);
  //         })
  //         .catch(function (err) {
  //             BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
  //             setIsLoading(false);
  //         });
  // }
  const request = (url, method, data) => {
    const { headers } = appConfig.apiSettings;
    headers.Authorization = session;

    axios({
      url,
      method,
      headers,
      data,
    })
      .then(function (res) {
        if (res?.data?.[0]?.statusCode === 400) {
          BOM.AlertMsg(cnt.DANGER, res?.data?.[0]?.body);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newGLIMLoanAppMsg);
          const objDetail = res;
          navigate("/detail-group", {
            state: {
              id: state?.id,
              statusValue: accountStatus.submittedAndPending,
            },
          });
        }
        //STOP LOAD
        setIsLoading(false);
      })
      .catch(function (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      });
  };
  const onSubmit = (formValues) => {
    formValues = {
      ...formData.details,
      ...formData.terms,
    };

    // CHARGES STICT VALUES
    formValues.charges = formData.charges;
    formValues.settings = formData.settings;
    formValues.loanPurposeId = loanPurposeOptions.find(
      (item) => item.label === formData.settings[0]?.loanPurposeId
    )?.value;
    formValues.groupId = state.id;
    formValues.expectedDisbursementDate = BOM.DateTime(
      formValues.expectedDisbursementDate,
      "only-date"
    );
    formValues.interestChargedFromDate = BOM.DateTime(
      formValues.interestChargedFromDate,
      "only-date"
    );
    formValues.repaymentsStartingFromDate = BOM.DateTime(
      formValues.repaymentsStartingFromDate,
      "only-date"
    );
    formValues.productId = productId;
    formValues.principal = principal;
    formValues.transactionProcessingStrategyId =
      templateProdDetail?.transactionProcessingStrategyId;
    formValues.inArrearsTolerance = templateProdDetail?.inArrearsTolerance;
    formValues.interestCalculationPeriodType =
      templateProdDetail?.interestCalculationPeriodType?.id;
    formValues.amortizationType = templateProdDetail?.amortizationType?.id;
    formValues.dateFormat = "dd MMMM yyyy";

    delete formValues.settings;
    delete formValues.on;
    delete formValues.day;
    delete formValues.interestChargedFromDate;
    delete formValues.repaymentsStartingFromDate;

    const applicationId = Math.floor(Math.random() * 9999999999 + 1);

    const url = `${apiConfig.Batches}?enclosingTransaction=true`;

    let body = [];
    selectedRows.forEach((element, index) => {
      body.push({
        body: JSON.stringify({
          ...formValues,
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          loanType: "glim",
          clientId: element?.clientId,
          applicationId,
          isParentAccount: index === 0 ? true : undefined,
          totalLoan:
            index === 0
              ? templateProdDetail?.approvedPrincipal * selectedRows.length
              : undefined,
          lastApplication: index + 1 === selectedRows.length ? true : false,
          syncDisbursementWithMeeting: false,
        }),
        method: "POST",
        relativeUrl: "loans",
        requestId: index,
      });
    });

    setIsLoading(true);
    request(url, "POST", body);
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newGLIMLoanApplication}
        pageItems={staticConfig.newGlimLoanApplicationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={labelConfig.glimLoanAccountSetup}
          style={styles.cardWrapper}
        >
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  {/* Navigation section */}
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={onChange}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>{labelConfig.details}</Text>,
                        },

                        {
                          title: <Text strong>{labelConfig.terms}</Text>,
                          disabled: isStepDisabled,
                        },

                        {
                          title: <Text strong>{labelConfig.charges}</Text>,
                          disabled: isStepDisabled,
                        },

                        {
                          title: <Text strong>{labelConfig.settings}</Text>,
                          disabled: isStepDisabled,
                        },

                        {
                          title: <Text strong>{labelConfig.preview}</Text>,
                          disabled: isStepDisabled,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    Prev
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {isLastStep && BOM.HasPermission("CREATE_LOAN") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GLIMLoanApplication);
